import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { del } from "../../lib/request"

export const deleteTopic = createAsyncThunk("deleteTopic/delete", async (postId, { rejectWithValue, getState }) => {
  try {
    const state = getState()
    const token = state.auth?.token

    if (!token) {
      console.error("No authentication token found")
      throw new Error("Authentication required. Please login first.")
    }

    if (!postId) {
      console.error(" No post ID provided")
      throw new Error("Post ID is required")
    }

    const endpoint = `posts/${postId}`
    const response = await del(endpoint)
  

    return { postId }
  } catch (err) {
    console.error("Error message:", err?.message)
    return rejectWithValue(err?.message || "Failed to delete post")
  }
})

const initialState = {
  status: "idle",
  error: null,
  deletedPostId: null,
}

const deleteTopicSlice = createSlice({
  name: "deleteTopic",
  initialState,
  reducers: {
    clearDeleteError: (state) => {
      state.error = null
    },
    resetDeleteStatus: (state) => {
      state.status = "idle"
      state.error = null
      state.deletedPostId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTopic.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(deleteTopic.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.deletedPostId = action.payload.postId
      })
      .addCase(deleteTopic.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload || "Failed to delete post"
      })
  },
})

export const { clearDeleteError, resetDeleteStatus } = deleteTopicSlice.actions

export default deleteTopicSlice.reducer
